import {
  ref,
  inject,
  onMounted,
  computed,
  onUnmounted,
  onActivated,
} from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { debounce, getDataLocation, setDataLocation } from "@/utils/index.js";

import api from "@/http/interface/index";
const useJobList = () => {
  const device = inject("device");
  const router = useRouter();
  const { t, locale } = useI18n();
  // 查询条件
  const activeSearch = ref(null);
  // 查询条件
  const searchList = ref([
    {
      filterName: computed(() => t("searchJob.locations")),
      showPopover: false,
      label: 2,
      selectedCode: {
        allValue: [],
      },
      key: computed(() => (locale.value === "en" ? "areaNameEn" : "areaName")),
      code: "areaCode",
      childrenKey: "childAreas",
      showSelectAll: true,
      selectList: [],
    },
    {
      filterName: computed(() => t("searchJob.brand")),
      showPopover: false,
      label: 2,
      selectedCode: {
        allValue: [],
      },
      key: "brandname",
      code: "brandcode",
      childrenKey: "childBrands",
      selectList: [],
    },
    {
      filterName: computed(() => t("searchJob.roleCategory")),
      showPopover: false,
      label: 1,
      selectedCode: {
        allValue: [],
      },
      key: "jobCategoryName",
      code: "jobCategoryValue",
      selectList: [],
    },
  ]);
  const loadingFlag = ref(false);
  // 关键字查询
  const keyWords = ref("");
  const page = ref(0);

  const jobCount = ref(0);
  // 职位列表
  const jobListData = ref([]);
  const jobListMapData = ref([]);
  const jobDetail = ref({});
  const currentPage = ref(1);
  const listLimit = ref(10);
  const currentPageNum = ref(0);
  const previousPath = ref("");

  onMounted(() => {
    // 获取前一个页面的路径
    previousPath.value = router.options?.history?.state?.back;
    if (previousPath.value === "/loading") {
      getFilterData();
    }
    const jobCategoryValue = router.currentRoute.value.query.jobCategoryValue;
    if (jobCategoryValue) {
      searchList.value[2].selectedCode.allValue = [Number(jobCategoryValue)];
    }
    resetListData();
    getPrivoceCity();
    // 获取职位分类
    getJobCategory();
    // 获取酒店品牌
    getHotelBrandObj();
  });
  onActivated(() => {
    //首页跳转获取职位分类
    const jobCategoryValue = router.currentRoute.value.query.jobCategoryValue;
    if (jobCategoryValue) {
      searchList.value[2].selectedCode.allValue = [Number(jobCategoryValue)];
      resetListData();
    }
  });
  // 在组件卸载时移除滚动监听
  onUnmounted(() => {});
  const getPrivoceCity = () => {
    api.getPrivoceCity().then((res) => {
      if (res.code == 200) {
        searchList.value[0].selectList = res.data || [];
      }
    });
  };
  // 获取品牌信息
  const getHotelBrandObj = () => {
    api.getHotelBrandObj().then((res) => {
      if (res.code == 200) {
        searchList.value[1].selectList = res.data || [];
      }
    });
  };
  // 获取职位类型
  const getJobCategory = () => {
    api.getJobCategory(2).then((res) => {
      if (res.code == 200) {
        searchList.value[2].selectList = res.data || [];
      }
    });
  };

  const changeFilter = (e, index) => {
    e.stopPropagation();
    if (activeSearch.value === index) {
      activeSearch.value = null;
    } else {
      activeSearch.value = index;
    }
    for (let i in searchList.value) {
      if (i == index) {
        if (searchList.value[i].showPopover) {
          searchList.value[i].showPopover = false;
        } else {
          searchList.value[i].showPopover = true;
        }
      } else {
        searchList.value[i].showPopover = false;
      }
    }
  };
  // 重置条件
  const resetFilter = (index) => {
    searchList.value[index].selectedCode = {
      allValue: [],
    };
    searchList.value[index].showPopover = false;
    activeSearch.value = null;
    resetListData();
  };
  //下拉 确认
  const confirmSelect = (selectData) => {
    activeSearch.value = null;
    selectData.showPopover = false;
    resetListData();
    saveFilterData();
  };
  //获取查询条件
  const getFilterData = () => {
    const filterData = JSON.parse(getDataLocation("filterData") || "{}") || {};
    keyWords.value = filterData.keyWords || "";
    sortType.value = filterData.sortType || null;
    filterType.value = filterData.filterType || "list";
    searchList.value[0].selectedCode = filterData.citySelectedCode || {
      allValue: [],
    };
    searchList.value[1].selectedCode = filterData.brankSelectedCode || {
      allValue: [],
    };
    searchList.value[2].selectedCode = filterData.categorySelectedCode || {
      allValue: [],
    };
    setDataLocation("filterData", JSON.stringify({}));
  };
  // 保存查询条件
  const saveFilterData = () => {
    const filterData = {
      keyWords: keyWords.value || "",
      sortType: sortType.value || "",
      filterType: filterType.value || "",
      citySelectedCode: searchList.value[0].selectedCode,
      brankSelectedCode: searchList.value[1].selectedCode,
      categorySelectedCode: searchList.value[2].selectedCode,
    };
    const filterDataString = JSON.stringify(filterData);
    setDataLocation("filterData", filterDataString);
  };
  // 排序方式
  const sortType = ref(null);
  const changeSortType = () => {
    sortType.value = sortType.value === 1 ? 2 : 1;
    page.value = 1;
    jobListData.value = [];
    jobCount.value = 0;
    currentPage.value = 1;
    currentPageNum.value = 0;
    getJobListData();
    saveFilterData();
  };

  // 监听滚动事件
  const handleScroll = debounce(() => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    const clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    // 当滚动到距离底部80px时触发加载
    let height = 80;
    if (device.value === "mb") {
      height = 30;
    }
    if (
      scrollTop + clientHeight >= scrollHeight - height &&
      !loadingFlag.value &&
      jobListData.value.length < jobCount.value
    ) {
      getJobListData();
    }
  }, 200); // 200ms防抖延迟

  // 显示类型
  const filterType = ref("list");
  const changeType = (type) => {
    filterType.value = type;
    saveFilterData();
  };
  // 关键字搜索
  const handleSearch = () => {
    resetListData();
    saveFilterData();
  };

  const goSearchJobResult = () => {
    router.push({
      path: "/searchJobResult",
      query: {
        keyWords: keyWords.value || "",
      },
    });
  };
  const resetListData = () => {
    page.value = 1;
    jobListData.value = [];
    jobListMapData.value = [];
    jobCount.value = 0;
    currentPage.value = 1;
    currentPageNum.value = 0;
    getJobListData();
    _getJobListMapData();
  };
  const changePageNumber = (pageNum) => {
    currentPage.value = pageNum;
    getJobListData();
  };

  // 获取职位列表分页
  const getJobListData = () => {
    if (loadingFlag.value === true) return;
    let params = {
      from:
        device.value === "mb"
          ? jobListData.value.length
          : (currentPage.value - 1) * listLimit.value,
      size: listLimit.value,
      jobAdName: keyWords.value, //关键字搜索支持酒店品牌，职位类型，职位关键字
      locId: searchList.value[0].selectedCode.allValue || [], //城市code列表
      hotelBrandName: searchList.value[1].selectedCode.allValue || [], // 品牌code列表
      innerChannelClassificationTwo:
        searchList.value[2].selectedCode.allValue || [], // 职位类型code列表
      postDateOrder: sortType.value,
    };
    loadingFlag.value = true;
    api
      .getJobList(params)
      .then((res) => {
        loadingFlag.value = false;
        if (res.code === "200") {
          if (device.value === "mb") {
            if (res?.data?.length && res?.data?.length > 0) {
              jobListData.value = [...jobListData.value, ...res.data];
            }
          } else {
            jobListData.value = res.data || [];
            currentPageNum.value = jobListData.value?.length || 0
          }
          jobCount.value = res.sum || 0;
        }
      })
      .catch((err) => {
        loadingFlag.value = false;
      });
  };

  const getJobDetail = (id) => {
    api
      .getJobDetail(id)
      .then((res) => {
        if (res.code === "200") {
          jobDetail.value = { ...res.data, jobAdId: id };
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const clearDetail = () => {
    jobDetail.value = {};
  };
  // 获取职位列表，地图
  const _getJobListMapData = () => {
    let params = {
      jobAdName: keyWords.value, //关键字搜索支持酒店品牌，职位类型，职位关键字
      locId: searchList.value[0].selectedCode.allValue || [], //城市code列表
      hotelBrandName: searchList.value[1].selectedCode.allValue || [], // 品牌code列表
      innerChannelClassificationTwo:
        searchList.value[2].selectedCode.allValue || [], // 职位类型code列表
    };
    api
      .getMapJobList(params)
      .then((res) => {
        console.log("res", res);
        if (res.code === "200") {
          if (res?.data?.length && res?.data?.length > 0) {
            jobListMapData.value = res?.data?.map((item) => {
              return {
                ...item,
                hotelInglatKey: item?.inglat,
                lnglat: ensureLngLatOrder(item.inglat) || [],
              };
            });
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  // 确保经纬度顺序：经度在前，纬度在后
  const ensureLngLatOrder = (coordString) => {
    if (!coordString) return [];

    // 分割坐标字符串（兼容中英文逗号）
    const coords = coordString.split(/[，,]/).map((coord) => coord.trim());
    if (coords.length !== 2) return [];

    const [first, second] = coords.map(Number);

    // 检查是否为有效的经纬度数值
    if (isNaN(first) || isNaN(second)) return [];

    // 全球经纬度范围判断
    const isLongitude = (val) => val >= -180 && val <= 180;
    const isLatitude = (val) => val >= -90 && val <= 90;

    // 情况1：第一个是经度，第二个是纬度（正确顺序）
    if (isLongitude(first) && isLatitude(second)) {
      return [first, second];
    }
    // 情况2：第二个是经度，第一个是纬度（需要交换）
    else if (isLongitude(second) && isLatitude(first)) {
      return [second, first];
    }
    // 情况3：两个值都在经度范围或都在纬度范围（无法确定，使用默认顺序）
    else if (
      (isLongitude(first) && isLongitude(second)) ||
      (isLatitude(first) && isLatitude(second))
    ) {
      return [first, second];
    }
    // 情况4：都不在有效范围内
    else {
      return [];
    }
  };

  return {
    locale,
    activeSearch,
    searchList,
    loadingFlag,
    keyWords,
    jobCount,
    jobListData,
    jobListMapData,
    jobDetail,
    currentPage,
    currentPageNum,
    sortType,
    filterType,
    previousPath,
    changeFilter,
    resetFilter,
    changeSortType,
    changeType,
    handleSearch,
    getJobDetail,
    clearDetail,
    confirmSelect,
    goSearchJobResult,
    handleScroll,
    changePageNumber,
    listLimit,
  };
};
export default useJobList;
